import Card from '@carvana/ds-card';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { NavPayloadAction } from '@carvana/merch-native';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useMemo } from 'react';
import Image from '~/components/common/Image';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import { BodyStyle } from '~/contracts/flp';
import { getCvnaIdFinanceFilters } from '~/utilities/flp/getCvnaId';
import { BodyType, Inventory, Price } from './VehicleCard.styles';

type OwnProps = {
  bodyStyle: BodyStyle;
};

export default function VehicleCard({ bodyStyle }: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { aggregateMap } = useFinancingContext();

  const { count, minimumMonthlyPayment: minMonthlyPayment } =
    aggregateMap.get(bodyStyle.key) || {};

  const url = useMemo(() => {
    const cvnaid = getCvnaIdFinanceFilters({
      bodyStyles: [bodyStyle.key],
      sortBy: 'MonthlyPayment'
    });

    return `/cars/filters?cvnaid=${cvnaid}&refSource=financing`;
  }, [bodyStyle.key]);

  const onClick = () => {
    datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.CLICKS_BODYSTYLE, {
      bodyStyle: bodyStyle.key
    });
    trackEvent(ANALYTICS_EVENTS.PREQUALIFIED.CLICKS_BODYSTYLE, {
      bodyStyle: bodyStyle.key
    });
  };

  return (
    <a
      data-analytics-id={`Financing ${bodyStyle.key} Vehicle Card Link`}
      data-native-payload={JSON.stringify({ action: NavPayloadAction.ViewSrp })}
      href={url}
      onClick={onClick}
      data-testid="vehicle-card"
    >
      <Card
        className="w-[300px] cursor-pointer hover:border-border-primary"
        classes={{ content: 'flex flex-col px-2xl pb-2xl gap-2xl' }}
        id={bodyStyle.displayName}
      >
        <div>
          <Image
            src={bodyStyle.image}
            alt="Vehicle Image"
            width={250}
            height={125}
          />
        </div>
        <div>
          <BodyType>
            {bodyStyle.displayName} starting at <br />
            <Price>${minMonthlyPayment}/mo</Price>
          </BodyType>
        </div>
        <div>
          <Inventory>{count?.toLocaleString('en-US')} Available</Inventory>
        </div>
      </Card>
    </a>
  );
}
